import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/superpowers/")({
  beforeLoad: ({ context }) => {
    throw redirect({
      to: "/superpowers/$uid",
      params: { uid: context.user.solutionUid },
    })
  },
})
